import { useEffect, useRef } from 'react';
import { useLocation } from 'wouter';
import { ENV } from '../env';

export const trackEvent = (eventName, params) => {
  if (typeof window !== 'undefined' && !!window.fbq) {
    window.fbq('track', eventName, params);
    console.log('Meta Pixel: Standard event tracked -', eventName, params);
  }
};

export const trackCustomEvent = (eventName, params) => {
  if (typeof window !== 'undefined' && !!window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }
};

const firePageview = () => {
  if (typeof window !== 'undefined' && !!window.fbq) {
    window.fbq('track', 'PageView');
  }
};

/**
 * MetaPixelPageTracker - Tracks PageView events on SPA route changes
 * Note: The base Meta Pixel code is in index.html for proper detection by Meta Pixel Helper
 */
function MetaPixelPageTracker() {
  const [location] = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    firePageview();
  }, [location]);

  return null;
}

/**
 * MetaPixel Component
 * - Base pixel code is now in public/index.html for proper detection by Meta Pixel Helper
 * - This component only handles SPA route change tracking
 */
export function MetaPixel() {
  return <MetaPixelPageTracker />;
}

export default MetaPixel;

